var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 2.26465H4.875C4.96094 2.26465 5.03125 2.19434 5.03125 2.1084V2.26465H10.9688V2.1084C10.9688 2.19434 11.0391 2.26465 11.125 2.26465H10.9688V3.6709H12.375V2.1084C12.375 1.41895 11.8145 0.858398 11.125 0.858398H4.875C4.18555 0.858398 3.625 1.41895 3.625 2.1084V3.6709H5.03125V2.26465ZM14.875 3.6709H1.125C0.779297 3.6709 0.5 3.9502 0.5 4.2959V4.9209C0.5 5.00684 0.570312 5.07715 0.65625 5.07715H1.83594L2.31836 15.292C2.34961 15.958 2.90039 16.4834 3.56641 16.4834H12.4336C13.1016 16.4834 13.6504 15.96 13.6816 15.292L14.1641 5.07715H15.3438C15.4297 5.07715 15.5 5.00684 15.5 4.9209V4.2959C15.5 3.9502 15.2207 3.6709 14.875 3.6709ZM12.2832 15.0771H3.7168L3.24414 5.07715H12.7559L12.2832 15.0771Z",
    fill: "#F55B5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dd0ba7cf9f143b07474bf841d6778fa4.svg";
export { ForwardRef as ReactComponent };